/**
 * Returns all leaf paths (dot-notation) of an object, stopping at arrays.
 * @param {object} obj
 * @param {string} prefix
 * @returns {{ path: string, value: unknown }[]}
 */
export const getLeafPaths = (obj, prefix = '') => {
  if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) {
    return [{ path: prefix, value: obj }];
  }
  return Object.entries(obj).flatMap(([key, val]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (val === null || typeof val !== 'object' || Array.isArray(val)) {
      return [{ path, value: val }];
    }
    return getLeafPaths(val, path);
  });
};

/**
 * Builds a nested object from a dot-notation path and a value - recursively for more fun
 * @param {string} path
 * @param {unknown} value
 * @returns {object}
 */
export const setAtPath = (path, value) => {
  const dotIndex = path.indexOf('.');
  if (dotIndex === -1) {
    return { [path]: value };
  }
  return { [path.slice(0, dotIndex)]: setAtPath(path.slice(dotIndex + 1), value) };
};

/**
 * Deep merges source into target. Arrays are replaced, not merged.
 * @param {object} origin
 * @param {object} override
 * @returns {object}
 */
export const deepMerge = (origin, override) => {
  const result = { ...origin };
  Object.entries(override).forEach(([key, val]) => {
    const isPlainObject = (v) => v !== null && typeof v === 'object' && !Array.isArray(v);
    if (isPlainObject(val) && isPlainObject(result[key])) {
      result[key] = deepMerge(result[key], val);
    } else {
      result[key] = val;
    }
  });
  return result;
};
